<template>
  <v-dialog v-model="modalShow" width="400" persistent>
    <v-card>
      <v-card-title class="headline" primary-title>
        <div class="d-flex flex-fill">
          <div>
            <small>{{ title ? title : commonTitle }}</small>
          </div>
          <div class="ml-auto cursor" @click="hide()">
            <v-icon style="color:#0c0c0c">mdi-close</v-icon>
          </div>
        </div>
      </v-card-title>

      <hr />

      <v-card-text class="pa-5">
        <div class="confirm-modal-content mb-6">{{ content }}</div>

        <div class="text-right">
          <v-btn class="no-shadow btn-common-outline" outlined depressed :loading="loading" @click="submit">{{
            btnText ? btnText : commonBtnText
          }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    btnText: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modalShow: false,
      commonBtnText: this.$t('actions.confirm'),
      commonTitle: this.$t('labels.confirmation')
    };
  },
  mounted() {
    this.modalShow = true;
  },
  watch: {
    show: function(val) {
      this.modalShow = this.show;
    },
    modalShow: function(val) {
      this.$emit('update:show', val);
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.data);
    },
    hide() {
      this.modalShow = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
.confirm-modal-content {
  font-size: 1rem;
}
</style>
